class FeedingSliderControls extends HTMLElement {
  connectedCallback() {
    this.table = JSON.parse(this.querySelector('[data-feeding-table]').textContent);
    this.cupData = JSON.parse(this.querySelector('[data-variant-cup-data]').textContent);
    this.mode = this.dataset.mode === 'whole_meal' ? 'whole_meal' : 'topper';
    this.slider = this.querySelector('[data-weight-slider]');
    this.weightOut = this.querySelector('[data-weight-value]');
    this.bagOut = this.querySelector('[data-bag-value]');
    this.bagUnit = this.querySelector('[data-bag-unit]');

    this.quantityInput = document.getElementById(this.dataset.quantityTarget);
    this.form = this.quantityInput ? this.quantityInput.form : null;
    this.variantInput = this.form ? this.form.querySelector('[name="id"]') : null;

    this.userEditedQuantity = false;
    // Quantity stays at 1 until the shopper moves the weight slider.
    this.weightChanged = false;

    this.slider.addEventListener('input', () => {
      this.weightChanged = true;
      this.userEditedQuantity = false;
      this.update();
    });

    // If the customer edits quantity directly (typing, or the theme's own +/- buttons),
    // stop overwriting their choice until the slider or variant changes again.
    this.quantityInput.addEventListener('change', () => {
      if (!this.settingQuantity) this.userEditedQuantity = true;
    });

    const toggleBtns = this.querySelectorAll('[data-mode-value]');
    toggleBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        toggleBtns.forEach((b) => b.classList.remove('is-selected'));
        btn.classList.add('is-selected');
        this.mode = btn.dataset.modeValue;
        this.userEditedQuantity = false;
        this.update();
      });
    });

    if (this.variantInput) {
      new MutationObserver(this.update.bind(this)).observe(this.variantInput, {
        attributes: true,
        attributeFilter: ['value'],
      });
      this.variantInput.addEventListener('change', () => {
        this.userEditedQuantity = false;
        this.update();
      });
    }

    this.update();
  }

  currentCupPerBag() {
    const variantId = this.variantInput ? this.variantInput.value : null;
    const cupPerBag = variantId ? this.cupData[variantId] : null;
    return cupPerBag ? parseFloat(cupPerBag) : null;
  }

  cupsPerDay(weight) {
    const brackets = this.table[this.mode] || [];
    const bracket = brackets.find((b) => weight >= b.min && weight <= b.max);
    if (!bracket) return null;
    const range = bracket.max - bracket.min || 1;
    const perLb = (bracket.max_cup - bracket.min_cup) / range;
    return bracket.min_cup + (weight - bracket.min) * perLb;
  }

  update() {
    const weight = parseFloat(this.slider.value);
    this.weightOut.textContent = weight;

    const cupsPerDay = this.cupsPerDay(weight);
    const cupPerBag = this.currentCupPerBag();

    if (cupsPerDay === null || !cupPerBag) {
      this.bagOut.textContent = '--';
      return;
    }

    // Calculated over 4 weeks (28 days); the label still reads "bags/mo."
    const DAYS_PER_PERIOD = 28;
    const bagsPerPeriod = (cupsPerDay * DAYS_PER_PERIOD) / cupPerBag;
    const rounded = bagsPerPeriod.toFixed(1);
    this.bagOut.textContent = rounded;
    this.bagUnit.textContent = rounded > 1 ? ' bags/mo.' : ' bag/mo.';

    if (this.weightChanged && !this.userEditedQuantity) {
      this.settingQuantity = true;
      this.quantityInput.value = Math.max(1, Math.round(bagsPerPeriod));
      this.quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      this.settingQuantity = false;
    }
  }
}

customElements.define('feeding-slider-controls', FeedingSliderControls);


(function () {
  function initHeaderClickMenus() {
    var containers = document.querySelectorAll('menu-dropdown[data-header-trigger="click"]');
    if (!containers.length) return;

    containers.forEach(function (container) {
      var triggers = Array.prototype.slice.call(container.querySelectorAll('.menu__item-title--header'));
      if (!triggers.length) return;

      function closeAll() {
        triggers.forEach(function (item) {
          item.classList.remove('open');
          var dropdown = item.nextElementSibling;
          if (dropdown && dropdown.classList.contains('mega-menu')) {
            dropdown.removeAttribute('style');
          }
        });
      }

      function positionMegaMenu(item) {
        var dropdown = item.nextElementSibling;
        if (!dropdown) return;

        var header = item.closest('.header');
        if (!header) return;

        if (dropdown.classList.contains('mega-menu') && dropdown.classList.contains('mega-menu--wide') && header.offsetWidth > 1024) {
          var itemRect = item.getBoundingClientRect();
          var headerRect = header.getBoundingClientRect();
          dropdown.style.left = (-itemRect.left + headerRect.left + 24) + 'px';
          dropdown.style.width = (header.offsetWidth - 48) + 'px';
        }
      }

      function openItem(item) {
        closeAll();
        item.classList.add('open');
        positionMegaMenu(item);

        var dropdown = item.nextElementSibling;
        if (dropdown) {
          dropdown.querySelectorAll('.menu__dropdown-child-item-link').forEach(function (link) {
            link.setAttribute('tabindex', '0');
          });
        }
      }

      // The theme has two separate hover mechanisms (a plain mouseenter
      // listener, and a one-time pointerover "pre-hover" system that fires
      // before the rest of the theme's JS even initializes), plus a
      // keyboard Enter handler on the dropdown icon. All three ultimately
      // call these same two methods on the container instance. Overriding
      // them here catches every hover path at the source instead of
      // needing to block each event type individually, and the event.type
      // check keeps Enter-to-open on the icon working while ignoring
      // hover-originated calls (mouseenter, pointerover).
      container.openHeaderMenu = function (event, item) {
        if (event && event.type === 'keyup') {
          openItem(item);
        }
      };
      container.closeDropdownMenu = function () {
        // No-op: closing is owned entirely by our click / outside-click /
        // Escape handlers below, so hover-driven and focusout-driven
        // closes from the theme are ignored.
      };

      triggers.forEach(function (item) {
        var dropdown = item.nextElementSibling;
        if (!dropdown) return;

        // Entire title bar (link, icon, whitespace) toggles open/close.
        item.addEventListener('click', function (event) {
          event.preventDefault();
          if (item.classList.contains('open')) {
            closeAll();
          } else {
            openItem(item);
          }
        });

        // Close this menu if a real link inside the open dropdown is clicked.
        dropdown.querySelectorAll('a').forEach(function (a) {
          a.addEventListener('click', function () {
            if (a.getAttribute('href') === '#') return;
            closeAll();
          });
        });
      });

      // Close on outside click.
      document.addEventListener('click', function (event) {
        var clickedInside = triggers.some(function (item) {
          return item.contains(event.target) || (item.nextElementSibling && item.nextElementSibling.contains(event.target));
        });
        if (!clickedInside) closeAll();
      });

      // Close on Escape.
      document.addEventListener('keyup', function (event) {
        if (event.key === 'Escape') closeAll();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeaderClickMenus);
  } else {
    initHeaderClickMenus();
  }
})();